<template>
	<div class="acessar-ata-itens">
		<menu-acoes
			class="botao-tamanho-arp"
			:nome-botao="placeholder"
			:nome="placeholder"
			cor-icone="--v-error-base"
			icone-secondary="arrow_drop_down"
			:outlined="true"
			:block="block"
			corDeFundo="grey"
			:acoes-menu="itensAdesao"
			tamanho-icone-menu="18px"
			@estornar="$emit('estornar')"
		>
		</menu-acoes>
	</div>
</template>
<script>
import { permissoes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'
import permissoesMixin from '@/views/mixins/permissoes-mixin'

export default {
	name: 'itens-adesao-btn-mais-acoes',
	mixins: [validacaoAta, permissoesMixin],
	props: {
		block: {
			type: Boolean,
		},
	},
	data() {
		return {
			placeholder: 'MAIS AÇÕES',
			itensAdesao: [
				this.criarItem('Estornar', 'mdi-clipboard-arrow-left', 'estornar', permissoes.ataAdesaoItemEstornar),
			],
		}
	},
	methods: {
		criarItem(titulo, iconeNome, evento, authorization) {
			return {
				titulo,
				icone: { nome: iconeNome },
				evento,
				authorization,
			}
		},
	},
}
</script>
<style lang="stylus">
.botao-tamanho-arp .v-btn
	width (116 / 16)rem !important
</style>
